<template>
  <panel title="Рефералы">
    <template slot="beforeBody">
      <b-alert variant="success mb-0" class="rounded-0  bg-info text-white" show>
        <!-- BEGIN row -->
        <div class="row">
          <!-- BEGIN col-7 -->
          <div class="col-xl-7 col-lg-8">
            <!-- BEGIN title -->
            <div class="mb-1">
              <b>Всего рефералов:</b>
              <span class="ms-2">
                <!--<i class="fa fa-info-circle" title="Total sales" v-b-popover.hover="'sdfsdf'"></i>-->
              </span>
            </div>
            <!-- END title -->
            <!-- BEGIN total-sales -->
            <div class="d-flex mb-1">
              <h2 class="mb-0">{{ data.ref_count }}</h2>
              <div class="ms-auto mt-n1 mb-n1">

              </div>
            </div>
            <!-- END total-sales -->
            <!-- BEGIN percentage -->
            <!--
						<div class="mb-3">
							<i class="fa fa-caret-up"></i> 0% больше чем на прошлой неделе
						</div>
						-->
            <!-- END percentage -->
            <hr class="bg-white bg-opacity-50" />
            <!-- BEGIN row -->
            <div class="row text-truncate">
              <!-- BEGIN col-6 -->
              <div class="col-8">
                <div class="fs-12px">Ваша реферальная ссылка:</div>
                <div class="fs-18px ">{{ data.ref_link }}</div>
                <!--<div class="progress h-5px rounded-3 mb-5px">
										<div class="progress-bar progress-bar-striped rounded-right bg-warning"
											style="width: 55%"></div>
									</div>-->
              </div>
              <!-- END col-6 -->
              <!-- BEGIN col-6 -->
              <div class="col-4">
                <div class="fs-12px">Заработано:</div>
                <div class="fs-18px fw-bold">{{ (+data.balance_ref + +data.balance_ref_buy).toFixed(2) }} руб.</div>
                <!--<div class="progress h-5px rounded-3  mb-5px">
										<div class="progress-bar progress-bar-striped rounded-right" style="width: 55%">
										</div>
									</div>-->
              </div>
              <!-- END col-6 -->
            </div>
            <!-- END row -->
          </div>
          <!-- END col-7 -->
          <!-- BEGIN col-5 -->
          <div class="col-xl-5 col-lg-4 align-items-center d-flex justify-content-center">
            <img src="/assets/img/svg/img-1.svg" height="150px" class="d-none d-lg-block " />
          </div>
          <!-- END col-5 -->
        </div>
        <!-- END row -->
      </b-alert>
    </template>
    <div v-if="data">

      <h3 class="pt-3">Рефералы:</h3>

      <p>
        Рефералы - это пользователи, которые первый раз зашли на сайт по вашей
        реферальной ссылке.
      </p>



      <h3 class="pt-3">Как набрать рефералов?</h3>

      <p>
        Чтобы стать вашим рефералом, пользователь должен зарегистрироваться
        (первый раз зайти на сайт) по вашей реферальной ссылке:
      </p>
      <div class="pb-4 me-3 ms-3">
        <div>
          <h4>
            <input type="text" onClick="this.select();" class="form-control" v-bind:value="data.ref_link" />
          </h4>
        </div>
      </div>

      <h2 class="mt-5">Ваши рефералы:</h2>
      <p>
        Все ваши рефералы. Бонус 20% начисляется только за рефералов с рейтингом > 0. Пожалуйста приглашайте только
        ответственных исполнителей.
      </p>
      <vue-good-table :columns="columns_refs" :rows="data.refs" :lineNumbers="false"
        :search-options="{ enabled: true, placeholder: 'Поиск...' }" :paginationOptions="{
          enabled: true,
          nextLabel: '',
          prevLabel: '',
          rowsPerPageLabel: 'Строк',
          ofLabel: 'из',
          allLabel: 'Все',
        }">
        <div slot="emptystate">
          <div class="text-center">
            Нет рефералов...
          </div>
        </div>
        <template slot="table-row" slot-scope="props">
          <span v-if="props.column.field == 'image'">
            <img onerror="javascript:this.src='/images/avatar/user.png'" v-bind:src="`/images/avatar/` + props.row.avatar"
              class="user-avatar" width="40" height="40" />
          </span>
          <span v-else-if="props.column.field == 'balance_day'">
            {{ props.row.rating > -6 ? props.row.balance_day : "Не учитывается" }}
          </span>
          <span v-else>
            {{ props.formattedRow[props.column.field] }}
          </span>
        </template>
      </vue-good-table>


      <h2 class="mt-5">Выплаты за рефералов:</h2>
      <p>
        Вы получаете <b>+{{ data.percent }}%</b> от всех денег, заработанных вашими
        рефералами. Бонус рассчитывается ежедневно в 6.00 часов утра
      </p>
      <vue-good-table :columns="columns_user_refs" :rows="data.user_refs" :lineNumbers="false"
        :search-options="{ enabled: true, placeholder: 'Поиск...' }" :paginationOptions="{
          enabled: true,
          nextLabel: '',
          prevLabel: '',
          rowsPerPageLabel: 'Строк',
          ofLabel: 'из',
          allLabel: 'Все',
        }">
        <div slot="emptystate">
          <div class="text-center">
            Нет начислений...
          </div>
        </div>
        <template slot="table-row" slot-scope="props">
          <span v-if="props.column.field == 'referrer.avatar'">
            <img onerror="javascript:this.src='/images/avatar/user.png'"
              v-bind:src="`/images/avatar/` + props.row.referrer.avatar" class="user-avatar" width="40" height="40" />
          </span>
          <span v-else>
            {{ props.formattedRow[props.column.field] }}
          </span>
        </template>
      </vue-good-table>


      <h2 class="mt-5">Выплаты за рекламодателей:</h2>
      <p>
        Рекламодатели - это пользователи, которые первый раз зашли на сайт по вашей
        реферальной ссылке и пополнили баланс.
        Если ваши рекламодатели пополняют баланс Вы получаете <b>+{{ data.percent }}%</b> сразу.
      </p>
      <vue-good-table :columns="columns_user_ref_buys" :rows="data.user_ref_buys" :lineNumbers="false"
        :search-options="{ enabled: true, placeholder: 'Поиск...' }" :paginationOptions="{
          enabled: true,
          nextLabel: '',
          prevLabel: '',
          rowsPerPageLabel: 'Строк',
          ofLabel: 'из',
          allLabel: 'Все',
        }">
        <div slot="emptystate">
          <div class="text-center">
            Нет начислений...
          </div>
        </div>
        <template slot="table-row" slot-scope="props">
          <span v-if="props.column.field == 'referrer.avatar'">
            <img onerror="javascript:this.src='/images/avatar/user.png'"
              v-bind:src="`/images/avatar/` + props.row.referrer.avatar" class="user-avatar" width="40" height="40" />
          </span>
          <span v-else>
            {{ props.formattedRow[props.column.field] }}
          </span>
        </template>
      </vue-good-table>

      <h5 class="mt-3">Всего приглашено рефералов: {{ data.ref_count }}</h5>
      <h5>Заработано на рефералах: {{ data.balance_ref }} руб.</h5>
      <h5>Заработано на рекламодателях: {{ data.balance_ref_buy }} руб.</h5>
      <h5>Итого заработано: {{ (+data.balance_ref + +data.balance_ref_buy).toFixed(2) }} руб.
      </h5>
    </div>

    <div v-else class="text-center  m-20 p-20">
      <h4>Загружаем....</h4>
    </div>
  </panel>
</template>

<script>
import HTTP from "../http";
import {show_error} from "../message";


export default {

  data() {
    return {
      loading: false,
      error: null,
      data: {ref_count: 0, balance_ref: 0, refs: []},
      columns_refs: [{
        label: '',
        field: 'image',
        width: '50px',
        tdClass: 'text-center',
        thClass: 'text-center'
      }, {
        label: 'Имя',
        field: 'name',
        thClass: 'align-middle text-nowrap',
        tdClass: 'align-middle text-nowrap'
      },
      {
        label: 'Ссылка',
        field: 'reg_link',
        thClass: 'align-middle text-nowrap hide-993',
        tdClass: 'align-middle text-nowrap hide-993'
      },
      {
        label: 'Дата',
        field: 'created_at',
        width: '15%',
        thClass: 'align-middle text-center text-nowrap hide-993',
        tdClass: 'align-middle text-center text-nowrap hide-993'
      },
      {
        label: 'Рейтинг',
        field: 'rating',
        type: 'number',
        width: '10%',
        tdClass: 'align-middle text-center text-nowrap hide-993',
        thClass: 'align-middle text-center text-nowrap hide-993'
      },
      {
        label: 'Сегодня',
        field: 'balance_day',
        type: 'number',
        width: '10%',
        tdClass: 'align-middle text-center text-nowrap',
        thClass: 'align-middle text-center text-nowrap'
      }, {
        label: 'Всего',
        field: 'balance_earn',
        type: 'number',
        width: '10%',
        tdClass: 'align-middle text-center hide-768',
        thClass: 'align-middle text-center  hide-768'
      }],
      columns_user_refs: [{
        label: '',
        field: 'referrer.avatar',
        width: '50px',
        tdClass: 'text-center',
        thClass: 'text-center'
      }, {
        label: 'Имя',
        field: 'referrer.name',
        thClass: 'align-middle text-nowrap',
        tdClass: 'align-middle text-nowrap'
      },
      {
        label: 'Дата',
        field: 'created_at',
        width: '15%',
        thClass: 'align-middle text-center text-nowrap hide-993',
        tdClass: 'align-middle text-center text-nowrap hide-993'
      },
      {
        label: 'Заработал',
        field: 'balance_day',
        type: 'number',
        width: '10%',
        tdClass: 'align-middle text-center text-nowrap hide-768',
        thClass: 'align-middle text-center text-nowrap hide-768'
      }, {
        label: 'Ваш бонус',
        field: 'reward',
        type: 'number',
        width: '10%',
        tdClass: 'align-middle text-center text-nowrap ',
        thClass: 'align-middle text-center text-nowrap  '
      }],
      columns_user_ref_buys: [{
        label: '',
        field: 'referrer.avatar',
        width: '50px',
        tdClass: 'text-center',
        thClass: 'text-center'
      }, {
        label: 'Имя',
        field: 'referrer.name',
        thClass: 'align-middle text-nowrap',
        tdClass: 'align-middle text-nowrap'
      },
      {
        label: 'Дата',
        field: 'created_at',
        width: '15%',
        thClass: 'align-middle text-center text-nowrap hide-993',
        tdClass: 'align-middle text-center text-nowrap hide-993'
      },
      {
        label: 'Пополнил',
        field: 'balance_buy',
        type: 'number',
        width: '10%',
        tdClass: 'align-middle text-center text-nowrap hide-768',
        thClass: 'align-middle text-center text-nowrap hide-768'
      }, {
        label: 'Ваш бонус',
        field: 'reward',
        type: 'number',
        width: '10%',
        tdClass: 'align-middle text-center text-nowrap ',
        thClass: 'align-middle text-center text-nowrap  '
      }],
    };
  },

  created() {
    this.fetchData();
  },

  methods: {
    fetchData() {
      this.loading = true;
      this.$insProgress.start();
      HTTP()
        .get("/referral")
        .then((resp) => {
          console.log('resp', resp)
          this.data = resp.data
        })
        .catch((error) => {
          show_error(this.$notify, this.$refs.form, error.response.data)
        })
        .finally(() => {
          this.loading = false;
          this.$insProgress.finish();
        });
    },
  },
};
</script>



<style>
.vgt-table th.sortable {
  background: var(--app-component-bg);
  color: var(--app-component-color);
}

.vgt-wrap__footer {
  background: var(--app-component-bg);
  color: var(--app-component-color);
}

.vgt-global-search {
  background: var(--app-component-bg);
  color: var(--bs-body-color);
}

.vgt-table td {
  background: var(--app-component-bg);
  color: var(--app-component-color);

}

.vgt-table.bordered td,
.vgt-table.bordered th {
  border-color: var(--app-component-table-border-color);
  color: var(--app-component-color);
}


.vgt-input,
.vgt-select {
  background: var(--app-component-bg);
  color: var(--bs-body-color);
  border-color: var(--app-component-table-border-color);
}


.vgt-global-search {
  border-color: var(--app-component-table-border-color);
}

.vgt-wrap__footer {
  border-color: var(--app-component-table-border-color);
}

.table {
  color: var(--app-component-color);
}


@media (max-width: 768px) {
  .hide-768 {
    display: none;
  }
}

@media (max-width: 992px) {
  .hide-993 {
    display: none;
  }
}
</style>